import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

export const OutstandingDetailDialog = ({ outstandingDialog, onClose, crmOutstandingByDealerId }) => (
  <Dialog open={!!outstandingDialog} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="outstanding-detail-dialog">
      <DialogHeader>
        <DialogTitle>
          Outstanding — {outstandingDialog?.order?.dealer_name}
        </DialogTitle>
      </DialogHeader>
      {outstandingDialog && (() => {
        const os = crmOutstandingByDealerId[outstandingDialog.order.dealer_id] || {};
        const invoices = outstandingDialog.detail?.outstanding_invoices || [];
        const total = invoices.reduce((s, i) => s + Number(i.due || 0), 0);
        const bucketColor = (d) => d > 30 ? '#C05C35' : d > 14 ? '#B08800' : '#2B5339';
        return (
          <div className="space-y-4">
            <div className="grid grid-cols-3 gap-3">
              <Card className="p-3">
                <div className="text-xs" style={{ color: '#5C6B61' }}>Total Outstanding</div>
                <div className="text-xl font-bold" style={{ color: '#C05C35' }}>
                  {'\u20B9'}{Number(os.outstanding_total || total || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}
                </div>
              </Card>
              <Card className="p-3">
                <div className="text-xs" style={{ color: '#5C6B61' }}>Invoices</div>
                <div className="text-xl font-bold">{invoices.length}</div>
              </Card>
              <Card className="p-3">
                <div className="text-xs" style={{ color: '#5C6B61' }}>Oldest Overdue</div>
                <div className="text-xl font-bold" style={{ color: bucketColor(os.oldest_od_days || 0) }}>
                  {os.oldest_od_days || 0}d
                </div>
              </Card>
            </div>

            {outstandingDialog.loading && (
              <div className="text-center py-8" style={{ color: '#5C6B61' }}>
                <Loader2 className="inline w-4 h-4 animate-spin mr-2" /> Loading…
              </div>
            )}
            {outstandingDialog.error && (
              <div className="text-sm p-3 rounded" style={{ background: '#FFF4F0', color: '#C05C35' }}>
                {outstandingDialog.error}
              </div>
            )}
            {!outstandingDialog.loading && !outstandingDialog.error && invoices.length === 0 && (
              <div className="text-sm p-4 text-center rounded" style={{ background: '#FBF9F6', color: '#5C6B61' }}>
                No invoice-level breakdown available for this dealer.
              </div>
            )}
            {!outstandingDialog.loading && invoices.length > 0 && (
              <div className="overflow-x-auto">
                <table className="w-full text-xs" data-testid="outstanding-invoices-table">
                  <thead>
                    <tr style={{ background: '#FBF9F6' }}>
                      <th className="p-2 text-left">Date</th>
                      <th className="p-2 text-left">Txn No.</th>
                      <th className="p-2 text-right">Net</th>
                      <th className="p-2 text-right">Due</th>
                      <th className="p-2 text-right">OD Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((inv, idx) => (
                      <tr key={idx} className="border-t" style={{ borderColor: '#E2DFD8' }}>
                        <td className="p-2 whitespace-nowrap">{inv.date || '-'}</td>
                        <td className="p-2 font-mono text-[11px]">{inv.txn_no || '-'}</td>
                        <td className="p-2 text-right">{'\u20B9'}{Number(inv.net || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}</td>
                        <td className="p-2 text-right font-semibold" style={{ color: '#C05C35' }}>
                          {'\u20B9'}{Number(inv.due || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}
                        </td>
                        <td className="p-2 text-right">
                          <span className="font-semibold" style={{ color: bucketColor(inv.od_days || 0) }}>
                            {inv.od_days || 0}d
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: '#2B5339', color: 'white' }}>
                      <td colSpan="3" className="p-2 text-right font-bold">Total Due</td>
                      <td className="p-2 text-right font-bold">{'\u20B9'}{total.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</td>
                      <td className="p-2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>
        );
      })()}
    </DialogContent>
  </Dialog>
);
